export default "__VITE_ASSET__BogutdP6__"